// extracted by mini-css-extract-plugin
export default {"container":"foxyP","header":"IEtW9","title":"DKLdx","close":"jzokH","itemsWrapper":"OFFcm","items":"PkQ7E"};